module.exports = __webpack_public_path__ + "5d5f1c7d5a4913353ce2721993d72327.MP3";